import styled from 'styled-components';

import StopAddressWhenEdit from 'components/form/StopAddressWhenEdit/container';

export default styled(StopAddressWhenEdit)``;
